/* Preserve the selected Zenit S frame size when changing finish. */
(()=>{if(window.poweronFamilyOptionsBound)return;window.poweronFamilyOptionsBound=true;
function update(link){const box=link.closest('[data-pf-options]');if(!box)return;
const scope=box.closest('.product-information')||box.parentElement;
const current=JSON.parse(box.querySelector('[data-pf-current-variants]').textContent);
const selected=scope.querySelector('form[action*="/cart/add"] input[name="id"]');
const id=selected?.value||new URL(location.href).searchParams.get('variant');
const variant=current.find(v=>String(v.id)===String(id));
if(!variant)return;
const target=JSON.parse(link.dataset.pfVariants).find(v=>v.size===variant.size);
if(target){const url=new URL(link.dataset.pfBase,location.origin);url.searchParams.set('variant',target.id);link.href=url.pathname+url.search;}
}
['pointerover','focusin','click'].forEach(type=>document.addEventListener(type,event=>{const link=event.target.closest?.('[data-pf-frame-link]');if(link)update(link);},true));
})();
